'use client'
import { useFetchUser } from '@/discord/hooks/useFetchUser'
import { useClientSession } from '@/discord/hooks/useFetchSession'
import { useEffect, useState } from 'react'
import { CircularProgress } from '@mui/material'

export const Mxpdisplay: React.FC = () => {
  const { data: session, isAuthenticated, isLoading: sessionLoading } = useClientSession()
  const { userData, isLoading: userDataLoading } = useFetchUser(session)
  const [mounted, setMounted] = useState(false)
  // Ensure this component only renders after the client has mounted
  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null // Prevent rendering on the server
  if (!isAuthenticated) return null

  const isLoading = sessionLoading || userDataLoading
  
  // Extract the points value from userData (assuming it's stored in a property like 'points' or 'mxp')
  // Adjust this based on your actual API response structure
  const points = userData || 0

  return (
    <>
      {session && (
        <div className='rounded-full items-center bg-primary/20 z-100'>
          <div className='flex rounded-full items-center p-1'>
            {!isLoading && userData ? (
              <p className='p-2 text-sm font-clash px-3 font-bold italic flex rounded-full bg-primary/10 border-primary border-opacity-20 text-center'>
                <span className='hidden md:block'>MXP&nbsp;</span>{points}
              </p>
            ) : (
              <CircularProgress size={18} color='secondary' />
            )}
          </div>
        </div>
      )}
    </>
  )
}
